export default __webpack_public_path__ + "static/5-7917359e629e2fed3d13fd335a3ac51a.png";